import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// BANK TO BANK TRANSFER VERIFICATION
// Legacy: /AccountsApproval/VerifyBankTransfer (+ Grid / VerifyBankTransferView / UpdateBankTransferView).
// The backend route names are legacy's own ("...Deposit") even though they serve bank-to-bank transfers.
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// Queue — transfers pending at this role's level (spGetAllbanktobanktransferDetailsGrid; row carries MOID).
export const getVerificationBankTransfers = async (roleId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetBankDeposit`, { params: { Roleid: roleId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail of one pending transfer (one-row list; adds AmountInWords).
export const getVerificationBankTransferByRefNo = async (refNo) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetBankVerificationdepositbyId`, { params: { RefNo: refNo }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail of a returned transfer for the resubmit form (carries FromId / ToId).
export const getReturnedBankTransferByRefNo = async (refNo) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetReturnbanktransferbyId`, { params: { BankTranrefno: refNo }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// "To Bank" dropdown for the resubmit form.
export const getBanks = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetBankDetails`, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Verify / Approve / Return / Reject (spVerifybanktobankdeposit — success literal "Submitted").
export const verifyBankTransfer = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/Verifybankdeposit`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Resubmit a returned transfer (SPBankToBankReturnTransfer — success literal "Successfull").
export const updateReturnedBankTransfer = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/UpdateTransfer`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
